
const SelectView = Backbone.View.extend({
	tagName: 'div',
	className: 'form-group',
	events: {
		'blur select.required': 'validate',
		'change select': 'onChange'
	},
	initialize(opts) {
		this.options = opts;
		const name = this.options.modelKey.split('-');
		if (this.model) {
			this.listenTo(this.model, 'change', this.updatedModel);
		}
		if (opts.template) {
			this.template = JST[opts.template];
		} else {
			this.template = JST.selectOnlyTpl;
		}
		this.subTemp = JST.optionTpl;
		if (this.collection.fetched) {
			this.render(this);
		} else {
			this.listenTo(this.collection, "sync", this.render.bind(this, opts));
		}
	},
	render(formOptions) {

		const options = _.extend({
			hideDefaultOption : false
		}, formOptions);

		this.$el.html(this.template(options));
	  _.forEach(this.collection.models, function (item, key) {
			this.$('select[name="' + formOptions.modelKey + '"]').append(this.subTemp(item.attributes));
		}, this);
		return this.el;
	},
	getValue() {
		const name = this.options.modelKey.split('-'),
			obj = {};
			let val = this.$('select').val();
		name.reduce((prev, curr, i) => {
			let value = (i + 1 === name.length) ? val : {};
			if (!isNaN(val)) {
				val = parseInt(val, 10);
			}
			return prev[curr] = value;
		}, obj);
		return obj;
	},
	onChange(e) {
		const { onChange, trigger} = this.options;
		if (trigger) {
			this.trigger(trigger, e);
		}
		// if (onChange) {
		// 	this[onChange](e);
		// }
	},
	updatedModel(args) {
		const name = this.options.modelKey.split('-');
		let val = (name.length > 1 && !_.isNull(this.model.get(name[0]))) ? this.model.get(name[0])[name[1]] : this.model.get(name[0]);
		val = _.isNull(val) ? '' : val;
		this.$('select').val(val);
	},
	validate() {
		var $this = this.$('select'),
			$valMsg = this.$('span.field-validation-valid'),
			isValid = true;
		if (!$this.hasClass('required')) {
			return true;
		}
		if ($valMsg.html() != "" && ($this.val().length < 1 || $this.val() == 0)) {
			$valMsg.html("");
			$this.removeClass('error');
		}
		if ($this.val() === null || $this.val() == 0) {
			$valMsg.html($this.data("val-required"));
			$this.addClass("error");
			isValid = false;
		} else {
			$valMsg.html("");
			if ($this.hasClass("error")) {
				$this.removeClass("error");
			}
		}
		return isValid;
	}
});

export default SelectView;
